import React from 'react';
import styles from './AdminMobileEventList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH3FontSize, registerGap2 } from '../constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';

const AdminMobileEventList = ({events}) => {
    if (!events || events.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }
    

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {/* 반복구간 */}
            {events && events.map((events, index) => (
                <FlexChild key={index} height="initial">
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap={registerGap2}>
                            <FlexChild>
                                <HorizontalFlex gap={registerGap2}>
                                    <FlexChild width="auto">
                                        {events.image ? (
                                            <img className={styles.eventImg} src={events.image} alt='공지사항 이미지' />
                                        ) : (
                                            <div>이미지 없음</div>
                                        )}
                                    </FlexChild>
                                    <FlexChild>
                                        <VerticalFlex>
                                            <FlexChild>
                                                <HorizontalFlex>
                                                    <FlexChild>
                                                        <P size={pageEH3FontSize}>
                                                            {events.title ? events.title : "제목 없음"}
                                                        </P>
                                                    </FlexChild>
                                                    <FlexChild width="auto">
                                                        {events.status ? (
                                                            <>
                                                                {events.status === "post" && (
                                                                    <div className={styles.statusBox}>
                                                                        <P size={pageEH3FontSize}>게시</P>
                                                                    </div>
                                                                )}
                                                                {events.status === "end" && (
                                                                    <div className={styles.statusEndBox}>
                                                                        <P size={pageEH3FontSize}>중지</P>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div>상태 없음</div>
                                                        )}
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild alignItems="flex-start">
                                                <HorizontalFlex gap={registerGap2}>
                                                    <FlexChild width="auto">
                                                        <P size={pageEH3FontSize}>
                                                            {events.startDate ? events.startDate : "시작 날짜 없음"}
                                                        </P>
                                                    </FlexChild>
                                                    <FlexChild width="auto">
                                                        <P size={pageEH3FontSize}>~</P>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <P size={pageEH3FontSize}>
                                                            {events.endDate ? events.endDate : "종료 날짜 없음"}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild>
                                        <HorizontalFlex>
                                            <FlexChild>
                                                <P size={pageEH3FontSize}>노출 페이지</P>
                                            </FlexChild>
                                            <FlexChild justifyContent="flex-end">
                                                <P size={pageEH3FontSize}>
                                                    {events.displayPage ? events.displayPage : 0} 페이지
                                                </P>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex>
                                            <FlexChild>
                                                <P size={pageEH3FontSize}>노출 위치</P>
                                            </FlexChild>
                                            <FlexChild justifyContent="flex-end">
                                                <P size={pageEH3FontSize}>
                                                    {events.displayPosition ? events.displayPosition : "위치 없음"}
                                                </P>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap={registerGap2}>
                                    <FlexChild>
                                        <div className={styles.modifyBtn}>
                                            <P size={pageEH3FontSize}>수정</P>
                                        </div>
                                    </FlexChild>
                                    <FlexChild>
                                        <div className={styles.deleteBtn}>
                                            <P size={pageEH3FontSize}>삭제</P>
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            ))}
            {/* 반복구간 */}
        </VerticalFlex>
    );
};

export default AdminMobileEventList;